import { render, staticRenderFns } from "./AcceptResetPassword.vue?vue&type=template&id=9086be18&scoped=true&lang=pug"
import script from "./AcceptResetPassword.vue?vue&type=script&lang=js"
export * from "./AcceptResetPassword.vue?vue&type=script&lang=js"
import style0 from "./AcceptResetPassword.vue?vue&type=style&index=0&id=9086be18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9086be18",
  null
  
)

export default component.exports